/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Edit tangent</h4>

<p>Edit the tangent at either endpoint of an edge.</p>

<p>While in "Tangent" mode, select an edge, clicking closer to the end of interest. Then click this button to rotate the tangent of that end.</p>

<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>M:</b> Edit tangent</li>
</ul>`;

export default function EditTangentAtVertexTooltip() {
    return h('div', { innerHTML: body });
}
